import { get } from 'lodash';

/**
 * Action menu option with optional slug action and default handler
 */
export interface ActionMenuOption {
  slug?: <T>(option: ActionMenuOption, map: T) => void;
  default?: <T>(option: ActionMenuOption, map: T) => void;
  [key: string]: unknown;
}

/**
 * Insert an array of strings into another array of strings, after a specific item
 * in the original array
 * @param original - the original array
 * @param insert - the array to insert
 * @param after - the item in the original to insert the new array after
 * @returns The modified array with inserted items
 */
export const insertArrayAfter = <T>(original: T[], insert: T[], after: T): T[] => {
  const index = original.indexOf(after);
  if (0 > index) return original;
  if (insert.length === 0) return original;
  if (index === original.length - 1) return original.concat(insert);
  const first = original.slice(0, index + 1);
  const last = original.slice(index + 1);
  return first.concat(insert.concat(last));
};

/**
 * Creates a handler function that executes the appropriate action from an option
 * @param map - The context map to pass to the action handler
 * @returns A function that takes an option and executes its action
 */
export const takeActionMenuOnClick =
  <T>(map: T) =>
  (option: ActionMenuOption): void => {
    const action = get(option, 'slug', null) as ((option: ActionMenuOption, map: T) => void) | null;
    if (action) {
      action(option, map);
      return;
    }

    const defaultOpt = get(option, 'default', null) as ((option: ActionMenuOption, map: T) => void) | null;

    if (defaultOpt) {
      defaultOpt(option, map);
      return;
    }

    return;
  };
